"use client"
import Image from "next/image";
import Link from "next/link";
import {Button} from "@/components/ui/button";
import AuthAction from "@/components/site/AuthAction";
import {Sheet, SheetClose, SheetContent, SheetHeader, SheetTrigger} from "@/components/ui/sheet";
import {getAssetUrl} from "@/lib/helpers/getAssetUrl";
import {useSession} from "next-auth/react";
import {
    NavigationMenu, NavigationMenuContent,
    NavigationMenuItem, NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger
} from "@/components/ui/navigation-menu";
import {Disclosure} from "@headlessui/react";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {useRouter} from "next/navigation";
export default function NavLanding({navItems, logo, withShaddow = true, sign= false}){
    const session = useSession();
    const router = useRouter();
    return(
      <header className={`${withShaddow ? 'shadow-2xl' : ''}`}>
          <nav className={"pt-7 pb-6 mx-16 hidden min-[900px]:flex justify-between items-center"}>
              <div className={"flex items-center gap-x-8"}>
                  <Link href={"/"}>
                      <img src={getAssetUrl(logo)} alt={"logo"} width={75} height={50}/>
                  </Link>
                  {navItems.map(function (item,index){
                      return(
                          <button key={index} className={"hover:underline text-lg font-medium"}>
                              <Link href={item.link}>
                                  {item.label}
                              </Link>
                          </button>
                      )
                  })}
                  {session.status === "authenticated" &&(
                      <NavigationMenu>
                          <NavigationMenuList>
                              <NavigationMenuItem>
                                <NavigationMenuTrigger className={"hover:underline text-lg font-medium"}>Mon espace</NavigationMenuTrigger>
                                <NavigationMenuContent>
                                    <div className="w-36 flex flex-col items-start gap-2 p-2">

                                        <button className={" hover:text-primary"}>
                                            <NavigationMenuLink asChild>
                                                <Link href={"/dashboard/communities"}>
                                                    Communautés
                                                </Link>
                                            </NavigationMenuLink>
                                        </button>
                                        <button className={" hover:text-primary"}>
                                            <NavigationMenuLink asChild>
                                                <Link href={"/dashboard/contacts"}>
                                                    Contacts
                                                </Link>
                                            </NavigationMenuLink>
                                        </button>
                                        <button className={" hover:text-primary"}>
                                            <NavigationMenuLink asChild>
                                                <Link href={"/dashboard/messages"}>
                                                    Messages
                                                </Link>
                                            </NavigationMenuLink>
                                        </button>
                                        <button className={" hover:text-primary"}>
                                            <NavigationMenuLink asChild>
                                                <Link href={`/profile/${session.data.user.user.id}`}>
                                                    Mon profil
                                                </Link>
                                            </NavigationMenuLink>
                                        </button>
                                        <button className={" hover:text-primary"}>
                                            <NavigationMenuLink asChild>
                                                <Link href={"/dashboard/profile/edit"}>
                                                    Paramètres
                                                </Link>
                                            </NavigationMenuLink>
                                        </button>
                                    </div>
                                </NavigationMenuContent>
                              </NavigationMenuItem>
                          </NavigationMenuList>
                      </NavigationMenu>
                  )}
              </div>
              <AuthAction
                  sign={sign}
                  action={() => router.push('/dashboard/')}
                  trigger={(
                      <Button>
                          Se connecter
                      </Button>
                  )}
                  placeholder={(
                      <Button asChild>
                          <Link href={"/dashboard"}>
                              Tableau de bord
                          </Link>
                      </Button>
                  )}
              />

          </nav>
          <nav className={"flex justify-between py-5 px-10 min-[900px]:hidden"}>
              <Link href={"/"}>
                  <img src={getAssetUrl(logo)} alt={"logo"} width={75} height={50}/>
              </Link>

              <Sheet>
                  <SheetTrigger asChild>
                      <button className="block min-[900px]:hidden relative w-9 space-y-1.5">
                          <div className="bg-stone-700 h-1"/>
                          <div className="bg-stone-700 h-1"/>
                          <div className="bg-stone-700 h-1"/>
                      </button>
                  </SheetTrigger>
                  <SheetContent>
                      <SheetHeader>
                          <div className={"flex justify-center"}>
                              <img src={getAssetUrl(logo)} alt={"logo"} width={75} height={50}/>
                          </div>

                      </SheetHeader>
                      {/*<SheetDescription>Navigation</SheetDescription>*/}

                      <div className="flex flex-col items-start gap-5 text-base font-bold">
                          {navItems.map(function (item,index){
                              return(
                                  <button key={index} className={"hover:underline font-medium"}>
                                      <Link href={item.link}>
                                          {item.label}
                                      </Link>
                                  </button>
                              )
                          })}

                      </div>
                      {session.status === "authenticated" && (
                          <Disclosure>
                              {({open}) =>(
                                  <>
                                      <Disclosure.Button className={"flex items-center font-medium justify-center gap-x-4 pt-5"}>
                                          Mon espace
                                          <ChevronDownIcon className={`${open ? 'rotate-180' : ''}`}/>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                          <div className={"flex flex-col items-start gap-y-2"}>
                                              <SheetClose asChild>
                                                  <Link href={"/dashboard/communities"} className={"hover:underline"}>
                                                      Communautés
                                                  </Link>
                                              </SheetClose>
                                              <SheetClose asChild>
                                                  <Link href={"/dashboard/contacts"} className={"hover:underline"}>
                                                      Contacts
                                                  </Link>
                                              </SheetClose>
                                              <SheetClose asChild>
                                                  <Link href={"/dashboard/messages"} className={"hover:underline"}>
                                                      Messages
                                                  </Link>
                                              </SheetClose>
                                              <SheetClose asChild>
                                                  <Link href={`/profile/${session.data.user.user.id}`} className={"hover:underline"}>
                                                      Mon profil
                                                  </Link>
                                              </SheetClose>
                                              <SheetClose asChild>
                                                  <Link href={"/dashboard/profile/edit"} className={"hover:underline"}>
                                                      Paramètres
                                                  </Link>
                                              </SheetClose>
                                          </div>
                                      </Disclosure.Panel>
                                  </>
                              )}
                          </Disclosure>
                      )}

                      <div className={"flex justify-center"}>
                          <AuthAction
                              trigger={(
                                  <Button>
                                      Se connecter
                                  </Button>
                              )}
                              action={() => router.push('/dashboard/')}
                              placeholder={(
                                  <Button asChild>
                                      <Link href={"/dashboard"}>
                                          Mon tableau de bord
                                      </Link>
                                  </Button>
                              )}
                          />
                      </div>
                  </SheetContent>
              </Sheet>
          </nav>
      </header>
    );
}